// Centralized Lumacofono navigation & identity for SbustaOP.
// Edit links here only. External experiences open in a new tab.

export const HOME_URL = "https://www.lumacofono.com";

// The four Lumacofono experiences. SbustaOP is the current app.
export const EXPERIENCES = [
  { key: "teorie", label: "Le teorie dal mondo", url: "https://www.lumacofono.com" },
  // Fruttipedia lives on its own subdomain — plain cross-subdomain link, same tab.
  { key: "fruttipedia", label: "Fruttipedia", url: "https://www.fruttipedia.lumacofono.com/", sameTab: true },
  { key: "ciurma", label: "Crea la tua ciurma", url: "https://ciurma.lumacofono.com" },
  { key: "sbustaop", label: "SbustaOP", url: "https://sbustaop.lumacofono.com", current: true },
];

export const SOCIAL = [
  { label: "Spotify", icon: "spotify", url: "https://open.spotify.com/show/2QRg3xuiNzzMweAuAr46zT" },
  { label: "YouTube", icon: "youtube", url: "https://www.youtube.com/@lumacofonopodcast" },
  { label: "Instagram", icon: "instagram", url: "https://www.instagram.com/lumacofono_podcast/" },
  { label: "TikTok", icon: "tiktok", url: "https://www.tiktok.com/@lumacofono.podcast" },
  { label: "Twitch", icon: "twitch", url: "https://www.twitch.tv/lumacofono" },
];

export const LOGO_SRC = "/logo-lumacofono.png";
